



















import { Component, Vue } from 'vue-property-decorator';
import { SystemSettingInfo } from '@/appsync/graphql/systemSettingInfo';
import { updateSystemSettingInfo } from '@/appsync/service/SystemSettingMutationService';
import { getSystemSettingInfoIfNotCreate } from '@/appsync/service/SystemSettingQueryService';
import { refreshStores } from '@/containers/globals/globalSharedService';
import GeneralSettingBody from '@/containers/templates/GeneralSettingBody.vue';
import { i18n } from '@/plugins/i18n/i18n';
import { commonModule } from '@/store/modules/CommonStore';
import { loginUserModule } from '@/store/modules/LoginUserStore';
import { UserInfo, LoginInfo, AnnouncementSetting } from '@/types/type';
import { SNACKBAR_TIMEOUT } from '@/utils/consts';

@Component({
  components: { GeneralSettingBody },
})
export default class GeneralSetting extends Vue {
  private loading: boolean = true;
  private isSaved: boolean = false;

  private isMultilanguageEnabled: boolean = true;
  private isJobSchedulerEnabled: boolean = false;
  private isPortalEnabled: boolean = false;
  private announcementSetting: AnnouncementSetting | null = null;
  private snackbarTimeout: number = SNACKBAR_TIMEOUT;

  public async created(): Promise<void> {
    await this.initialize();
    this.loading = false;
  }

  private get savedMessage(): string {
    return i18n.tc('common.saved');
  }

  private get userInfo(): UserInfo {
    return loginUserModule.userInfo;
  }

  private get loginInfo(): LoginInfo {
    return commonModule.loginInfo;
  }

  private async saveGeneralSetting(
    generalSetting: SystemSettingInfo
  ): Promise<void> {
    await updateSystemSettingInfo({
      ...commonModule.loginInfo,
      ...generalSetting,
    });
    this.isSaved = true;
    await this.initialize();
  }

  private async initialize(): Promise<void> {
    const loginInfo: LoginInfo = commonModule.loginInfo;
    const systemSettingInfo = await getSystemSettingInfoIfNotCreate(
      loginInfo.tenant,
      loginInfo.landscape
    );
    this.isMultilanguageEnabled = systemSettingInfo.isMultilanguageEnabled;
    this.isJobSchedulerEnabled = systemSettingInfo.isJobSchedulerEnabled;
    this.isPortalEnabled = systemSettingInfo.isPortalEnabled;
    this.announcementSetting = systemSettingInfo.announcementSetting;
  }
}
